import { FieldValues, UseFormReturn } from "react-hook-form";
import { IField } from "@/api/AppApi/services/builder/interfaces/interfaces";
import { useEffect, useState } from "react";
import CommonDateTimeInput from "@/app/components/common-form-builder/common-fields/hooks-date-time/CommonDateTimeInput";
import RadioHook from "@/app/components/pages-components/checkout/checkout-helpers/RadioHook";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { RecievingFields } from "../helpers";
interface Props {
  form: UseFormReturn<FieldValues, any>;
  timeTypeFieldName: string;
  timeField: IField;
}

const ReceivingTime: React.FC<Props> = ({
  form,
  timeTypeFieldName,
  timeField,
}) => {
  const t = useTranslation();
  useEffect(() => {
    form.setValue(timeTypeFieldName, "now");
    setShowTimeInput(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.watch(RecievingFields.recievingFieldName)]);

  const [showTimeInput, setShowTimeInput] = useState(false);
  return (
    <div
      className="branch"
      style={{ display: "flex", flexDirection: "column", gap: 10 }}
    >
      <RadioHook
        form={form}
        option={{ id: "now", value: t.now }}
        fieldName={timeTypeFieldName}
        onOptionChange={() => {
          setShowTimeInput(false);
        }}
        isRequired
      />
      <div>
        <RadioHook
          form={form}
          option={{ id: "custom", value: t.schedule_for_later }}
          fieldName={timeTypeFieldName}
          onOptionChange={() => {
            setShowTimeInput(true);
          }}
          isRequired
        />
        {showTimeInput && (
          <CommonDateTimeInput
            form={form}
            field={timeField}
            minDate={new Date()}
          />
        )}
      </div>
    </div>
  );
};

export default ReceivingTime;
